import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SiteLayout from '../../components/feature/SiteLayout';

const FEATURES = [
  {
    icon: 'ri-stack-line',
    title: '丰富的内容库',
    desc: '覆盖电影、电视剧及多种主流类型，持续更新资源，满足不同口味。',
  },
  {
    icon: 'ri-filter-3-line',
    title: '清晰的分类筛选',
    desc: '按类型、地区、年份、评分多维筛选，几步就能锁定想看的作品。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '便捷的关键字检索',
    desc: '支持片名、演员、地区与类型的模糊搜索，快速直达目标内容。',
  },
  {
    icon: 'ri-closed-captioning-line',
    title: '中文字幕优先',
    desc: '资源均标注中文字幕状态，让中文用户观影更省心。',
  },
];

const CONTACTS = [
  { icon: 'ri-mail-line', label: '联系邮箱', value: 'support@zhongwenzimu.example.com' },
  { icon: 'ri-weibo-line', label: '官方微博', value: '@中文字幕永久在线' },
  { icon: 'ri-customer-service-2-line', label: '意见反馈', value: 'feedback@zhongwenzimu.example.com' },
  { icon: 'ri-map-pin-line', label: '办公地址', value: '中国 · 上海市浦东新区影视文化产业园' },
];

const NOTES = [
  '本站所有影视信息均为演示数据，仅用于展示平台功能与交互设计。',
  '播放区域为播放器界面演示，不提供真实视频流播放能力，请知悉。',
  '收藏功能保存在本地浏览器中，更换设备或清除浏览器数据后收藏记录将无法恢复。',
  '站内搜索、筛选、排序等功能均在演示数据范围内生效。',
];

export default function About() {
  useEffect(() => {
    document.title = '关于我们 - 中文字幕永久在线';
    const desc = document.querySelector('meta[name="description"]');
    if (desc)
      desc.setAttribute(
        'content',
        '了解中文字幕永久在线的平台定位、内容范围与使用说明，我们致力于为中文用户提供清晰分类的高清中文字幕影视浏览体验。',
      );
  }, []);

  return (
    <SiteLayout>
      <section className="w-full bg-secondary-900">
        <div className="w-full px-4 md:px-8 py-14 md:py-20">
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/10 text-background-200 text-xs mb-4">
              <i className="ri-film-line" aria-hidden="true"></i>
              关于中文字幕永久在线
            </span>
            <h1 className="font-heading font-extrabold text-3xl md:text-5xl text-background-50 leading-tight mb-5">
              让每一位中文观众
              <br className="hidden sm:block" />
              都能轻松找到想看的好片
            </h1>
            <p className="text-sm md:text-base text-background-300 leading-relaxed">
              中文字幕永久在线是一个专注于中文观影用户的内容门户，汇集高清电影与电视剧资源，以清晰的分类、便捷的筛选与检索，
              帮助用户从海量内容中快速找到心仪的作品。
            </p>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-50">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-start">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="w-1 h-6 md:h-7 rounded-full bg-primary-500"></span>
              <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">网站介绍</h2>
            </div>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              我们面向广大喜欢在线观看带中文字幕影视作品的用户，提供丰富、分类清晰的影视资源与便捷的浏览体验。
              无论是偏爱院线大片的影迷，还是喜欢追更剧集的追剧党，都可以在这里按类型、地区、年份与评分自由浏览。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              平台注重信息层级的清晰与内容的真实对应：每一条影视卡片的信息都与详情页保持一致，
              让用户在列表与详情之间的浏览始终连贯、没有断层。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              此外，我们通过编辑专题与热门排行，帮助用户发现更多值得一看的作品，让「选片」这件事变得轻松又愉快。
            </p>
          </div>

          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="w-1 h-6 md:h-7 rounded-full bg-accent-500"></span>
              <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">内容范围与特色</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
              {FEATURES.map((item) => (
                <div key={item.title} className="p-5 rounded-lg bg-background-100 border border-background-200">
                  <span className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 mb-3">
                    <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <h3 className="font-heading font-semibold text-sm text-foreground-950 mb-1.5">{item.title}</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
        <div className="flex items-center gap-3 mb-6">
          <span className="w-1 h-6 md:h-7 rounded-full bg-primary-500"></span>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">联系方式</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {CONTACTS.map((item) => (
            <div key={item.label} className="p-5 rounded-lg bg-background-50 border border-background-200">
              <span className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 mb-3">
                <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <p className="text-xs text-foreground-500 mb-1">{item.label}</p>
              <p className="text-sm text-foreground-900 font-medium break-all">{item.value}</p>
            </div>
          ))}
        </div>
        <p className="text-xs text-foreground-400 mt-4">
          以上联系方式为演示信息，仅用于展示页面布局，暂不支持实际提交与回信。
        </p>
      </section>

      <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-50">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          <div className="rounded-lg bg-background-100 border border-background-200 p-6 md:p-8">
            <h2 className="font-heading font-bold text-lg md:text-xl text-foreground-950 mb-5">使用注意事项</h2>
            <ul className="space-y-4">
              {NOTES.map((note) => (
                <li key={note} className="flex items-start gap-3">
                  <span className="w-8 h-8 shrink-0 flex items-center justify-center rounded-full bg-primary-50 text-primary-600">
                    <i className="ri-checkbox-circle-line text-base" aria-hidden="true"></i>
                  </span>
                  <p className="text-sm text-foreground-700 leading-relaxed pt-1">{note}</p>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg bg-secondary-900 p-6 md:p-8">
            <h2 className="font-heading font-bold text-lg md:text-xl text-background-50 mb-5">版权声明</h2>
            <div className="space-y-4 text-sm text-background-300 leading-relaxed">
              <p>
                本站为影视内容展示与检索演示平台，站内所有影片名称、封面、剧情简介等均为演示数据，
                不对应任何真实影视作品，亦不提供任何实际视频播放服务。
              </p>
              <p>
                本站不存储、不传播任何受版权保护的视频内容。若您对站内演示内容有任何疑问，
                欢迎通过上方联系方式与我们沟通。
              </p>
              <p>本声明最终解释权归中文字幕永久在线所有。</p>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 mt-12">
          <Link
            to="/"
            className="flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-home-4-line" aria-hidden="true"></i>
            返回首页
          </Link>
          <Link
            to="/category/featured"
            className="flex items-center gap-2 h-11 px-6 rounded-md border border-background-300 hover:border-primary-400 hover:text-primary-600 text-foreground-700 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-bookmark-3-line" aria-hidden="true"></i>
            浏览编辑专题
          </Link>
        </div>
      </section>
    </SiteLayout>
  );
}